import styled from 'styled-components'
import { rem } from 'polished'
import { Body20, Eyebrow, Title60, Standfirst } from 'components/Typography'
import { Container } from 'styles/sharedStyle'

export const ArticleTextCopy = styled(Body20)`
  h4 {
    font-family: ${({ theme }) => theme.textStyles.frontPrimary};
  }
`

export const ArticleTextWrapper = styled(Container)`
  padding: 0 40px;

  ${(props) =>
    props.isGeneric &&
    `word-break: break-word;

    ${({ theme }) => theme.mediaQueries.mobile} {
      padding: 0 20px;
    }
  `}

  ${ArticleTextCopy} {
    color: ${(props) => props.theme.colors.sagemediumToBlack};
    margin: 0 auto;
    max-width: 580px;
    h3 {
      font-family: ${({ theme }) => theme.textStyles.fontPrimaryThin};
    }
    a {
      text-decoration: underline;
    }

    p {
      font-size: ${rem(20)};
    }

    ${(props) =>
      props.isGeneric &&
      `color: ${props.theme.colors.sagedarkToBlack};
      max-width: 780px;

      p {
        font-size: 16px;
      }

      > h1 {
        margin-top: 0;
      }
    `}
  }

  ${({ centered }) =>
    !!centered &&
    `
    ${ArticleTextCopy} {
      text-align: center;

      p {
        font-size: ${rem(16)};
      }

      img {
        display: block;
        height: auto;
        margin: 0 auto;
        max-width: 100%;
      }
    }
  `}
`

export const ArticleIntroCopy = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.space[4]} 0 ${({ theme }) => theme.space[6]} 0;
  word-break: break-word;

  color: ${({ theme }) => theme.colors.sagedark};

  p {
    text-align: center;
    ${({ theme }) => theme.textStyles.title32};
    font-size: ${rem(26)};
    color: ${(props) =>
      props.isIntersecting
        ? props.theme.colors.white
        : props.theme.colors.sagedark}};
  }

  a {
    ${({ theme }) => theme.textStyles.title32};
    text-decoration-thickness: 0.05em;
    color: ${(props) =>
      props.isIntersecting
        ? props.theme.colors.white
        : props.theme.colors.sagedark}};
  }

  ${({ theme }) => theme.mediaQueries.large} {
    p {
      font-size: ${rem(32)};
    }
    a {
      font-size: ${rem(32)};
      text-decoration-thickness: 2;
    }
  }

  transition: color 0.5s ease;
`

export const ArticleQuoteWrapper = styled.blockquote`
  margin: 0;
  padding: 0 40px;
`

export const ArticleQuoteInner = styled.blockquote`
  margin: 0 auto;
  max-width: 776px;
  text-align: center;
  width: 100%;

  ${({ theme }) => theme.mediaQueries.large} {
    text-align: left;
  }
`

export const ArticleQuoteIco = styled.svg`
  display: block;
  fill: ${({ theme }) => theme.colors.sagedarkToGreen};
  height: 30px;
  margin: 0 auto 26px;
  width: 45px;

  ${({ theme }) => theme.mediaQueries.large} {
    height: 46px;
    margin: 0 0 14px;
    width: 69px;
  }
`

export const ArticleQuoteCopy = styled(Title60)`
  color: ${({ theme }) => theme.colors.sagedarkToBlack};
  font-size: ${rem(42)};
  font-family: ${({ theme }) => theme.textStyles.fontPrimaryThinItalic};

  ${({ theme }) => theme.mediaQueries.medium} {
    font-size: ${rem(60)};
  }
`

export const ArticleQuoteAuthor = styled.footer`
  color: ${({ theme }) => theme.colors.sagedarkToBlack};
  font-size: ${rem(10)};
  letter-spacing: 1.5px;
  line-height: 12px;
  margin: 18px 0 0;
  text-transform: uppercase;

  ${({ theme }) => theme.mediaQueries.large} {
    margin: 30px 0 0;
  }

  p {
    margin: 2px 0 0;

    &:first-child {
      color: ${({ theme }) => theme.colors.sagedarkToBlack};
      margin: 0;
    }
  }
`

export const ArticleIntroWrapper = styled.div`
  margin: 0;
  padding: 0 40px;
`

export const ArticleIntroInner = styled.div`
  margin: 0 auto;
  max-width: 780px;
  text-align: center;
`

export const ArticleIntroMeta = styled.div`
  margin: 0 0 42px;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.mediaQueries.large} {
    margin: 0 0 30px;
  }
`

export const ArticleIntroByline = styled(Standfirst)`
  margin: 0 0 10px;
`

export const ArticleIntroPublished = styled(Eyebrow)`
  margin: 0;
`
